/** @format */

import { SVGProps } from "react";

const SuccessIcon = (
  props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>
) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    {...props}
  >
    <path
      d="M9 17.7c-1.2 0-2.33-.23-3.387-.688A8.812 8.812 0 0 1 2.85 15.15a8.826 8.826 0 0 1-1.863-2.763A8.433 8.433 0 0 1 .3 9c0-1.2.229-2.33.687-3.388A8.83 8.83 0 0 1 2.85 2.85 8.827 8.827 0 0 1 5.613.987 8.433 8.433 0 0 1 9 .3c1.2 0 2.33.229 3.388.687A8.83 8.83 0 0 1 15.15 2.85a8.831 8.831 0 0 1 1.863 2.762A8.44 8.44 0 0 1 17.7 9c0 1.2-.23 2.329-.687 3.387a8.827 8.827 0 0 1-1.863 2.763 8.815 8.815 0 0 1-2.762 1.862A8.43 8.43 0 0 1 9 17.7Zm-1.45-5 6.2-6.2-.5-.5-5.7 5.7L4.7 8.85l-.5.5 3.35 3.35Z"
      fill="#0EA163"
    />
  </svg>
);
export default SuccessIcon;
